export default "__VITE_ASSET__823f28c7__"